import React from 'react';

const Card = ({children}) => {

    return <div className={`p-5 surface-1 rounded-xl w-full shadow-lg border`}>
        {children}
    </div>
}

export default Card;
